import { useOnboardingStore } from '@/store/onboardingStore';
import { suggestName, seedMessage } from '@/onboarding/createWizard';
import type { BuildInputs } from '@/build-core';

export function buildInputsFromStore(signedIn: boolean): BuildInputs {
  const s = useOnboardingStore.getState();
  const goal = s.description;
  // The plan's name wins: it is what the user saw on the review screen and approved.
  const appName = s.appPlan?.appName?.trim() || s.name.trim() || suggestName(goal);
  const base = s.clarifyMessages.length
    ? s.clarifyMessages
    : [{ role: 'user' as const, content: seedMessage({ ...s, plan: s.selectedPlan }) }];
  return {
    goal,
    appName,
    kind: s.kind,
    messages: base,
    vibe: s.vibe,
    selectedPlan: s.selectedPlan,
    seed: { enabled: s.seedEnabled, source: s.seedSource, description: s.seedDescription },
    ai: { enabled: s.aiEnabled, description: s.aiDescription },
    signedIn,
  };
}
